import { API_URL } from './Config';
import { startLoading, endLoading, SnackBar, handleHTTPError, ShowLoadingSpinner } from './CommonActions';
import store from '../store';
import axios from 'axios';

export function clearCard() {
    return {
        type: 'CLEAR_CARD_DETAILS'
    }
}

export function handleBooking(data, tour) {
    return {
        type: 'ADD_TOUR_BOOKING_DETAILS', data, tour
    }
}

export function handleVehicleBooking(data) {
    return {
        type: 'ADD_VEHICLE_BOOKING_DETAILS', data
    }
}

export function handleRedirection(bool) {
    return {
        type: 'CHECKOUT_REDIRECTION', bool
    }
}

export function payDayTour(info, data, tour) {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/day_tour/pay', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify({ info, data, tour }),
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    if (json.success) {
                        window.location.href = json.data.paymentUrl;
                    }
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}



export function payRoundTour(info, data, tour) {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/round_tour/pay', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify({ info, data, tour }),
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    if (json.success) {
                        window.location.href = json.data.paymentUrl;
                    }
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function bookMaldiveTour(info, data, tour) {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/maldive/booking', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify({ info, data, tour }),
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    if (json.success) {
                        window.location.href = json.data.paymentUrl;
                    }
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function payVehicleTransfer(info, data) {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/vehicle_transfer/pay', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify({ info, data }),
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    if (json.success) {
                        window.location.href = json.data.paymentUrl;
                    }
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}

export function payRentCarService(info, data, vehicle) {
    return function (dispatch) {
        dispatch(startLoading());
        fetch(API_URL + '/api/rent_car/pay', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify({ info, data, vehicle }),
        }).then(handleHTTPError)
            .then((response) => {
                dispatch(endLoading());
                response.json().then((json) => {
                    dispatch(endLoading());
                    if (json.success) {
                        window.location.href = json.data.paymentUrl;
                    }
                });
            }).catch((error) => {
                dispatch(endLoading());
                dispatch(SnackBar(true, 'Could not load data', 'error'));
            });
    }

}